<template>
  <div class="DataTable">
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="fullPage"
        color="#018389"
        loader="dots"
      ></loading>
    </div>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs12 pa-2>
          <span v-if="this.kolicinaVina > 0"
            >Faza {{ this.faza_mark }} / Količina {{ this.kolicinaVina }}
            {{ this.jm_mark }}</span
          >
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs2 pa-2>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
            :disabled="!edit"
          >
            <v-text-field
              slot="activator"
              v-model="dateFormatted"
              label="Datum"
              readonly
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              @blur="date = parseDate(dateFormatted)"
              :disabled="!edit"
            ></v-text-field>
            <v-date-picker
              v-model="date"
              no-title
              @input="menu = false"
              :max="maxDate"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs1 pa-2>
          <v-menu
            ref="menu1"
            :close-on-content-click="false"
            v-model="menu1"
            :nudge-right="0"
            :return-value.sync="time"
            transition="scale-transition"
            lazy
            offset-y
            full-width
            min-width="290px"
            @input="
              (value) =>
                value && $refs.picker && ($refs.picker.selectingHour = true)
            "
            :disabled="!edit"
          >
            <v-text-field
              slot="activator"
              v-model="time"
              label="Vreme"
              readonly
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              :disabled="!edit"
            ></v-text-field>
            <v-time-picker
              readonly
              v-model="time"
              ref="picker"
              full-width
              landscape
              class="mt-3"
              format="24hr"
              :allowed-minutes="allowedStep"
              v-on:change="$refs.menu1.save(time)"
            >
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="menu1 = false">Cancel</v-btn>
              <!-- <v-btn flat color="primary" @click="$refs.menu1.save(time)">OK</v-btn> -->
            </v-time-picker>
          </v-menu>
        </v-flex>
        <v-flex xs4 pa-2>
          <v-select
            ref="element1"
            v-model="parameter_select"
            :items="Parameter_items"
            item-text="name"
            item-value="id"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            label="Parametar"
            required
            persistent-hint
            return-object
            v-on:change="changeRoute"
            :disabled="!edit"
          ></v-select>
        </v-flex>

        <v-flex xs2 pa-2>
          <!-- <v-text-field v-model="value" ref="element2" label="Vrednost" 
          :rules="[rules.password]" 
          required></v-text-field> -->

          <v-text-field
            v-model="value"
            ref="element2"
            label="Vrednost"
            required
            :disabled="!edit"
          ></v-text-field>
        </v-flex>
        <v-flex xs1 pa-2>
          <v-select
            ref="element3"
            v-model="select"
            :items="jm_items_dodatak"
            item-text="mark"
            item-value="id"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            label="JM"
            required
            persistent-hint
            return-object
            :disabled="!edit"
          ></v-select>
        </v-flex>
        <v-flex xs2 pa-2>
            <v-checkbox
              label="Pre flaširanja"
              v-model="pre_flasiranja"
              :disabled="!edit || faza_za_flasiranje==='false'"
            ref="element5"

            ></v-checkbox>
          </v-flex>
      </v-layout>
      <!-- /.Name -->

      <v-layout row wrap v-if="tip_tanka === '15'">
        <v-flex xs12 pa-2>
          <v-autocomplete
            ref="elementsarza"
            v-model="sarza_select"
            :items="sarza_items"
            :item-text="getFieldText"
            item-value="tank.id"
            label="Barik"
            multiple
            chips
            deletable-chips
            hide-no-data
            clearable
            :disabled="!edit"
          ></v-autocomplete>
          <!--  -->
        </v-flex>
        </v-layout>
        <v-layout row wrap>
        <v-flex xs12 pa-2>
          <v-text-field
            v-model="opis"
            ref="element4"
            label="Opis"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <!-- /.Tank -->

      <v-layout row wrap>
        <v-flex xs12>
          <v-btn
            :disabled="!valid"
            @click="submit"
            class="AppButtonFilled"
            >Sačuvaj</v-btn
          >
          <v-btn
            @click="clear"
            class="AppButtonOutlined"
            
            >odustani</v-btn
          >
        </v-flex>
      </v-layout>
      <!-- /.Action buttons -->
    </v-form>
    <TokenComponent ref="frmtoken" />
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import { serverBus } from "../main";
import { readJSON, isNumeric } from "../helpers/Functions";
import TokenComponent from "../components/Token";

export default {
  name: "MeasurementItem",
  components: {
    TokenComponent,
    Loading,
  },
  data: () => ({
    isLoading: false,
    loading: true,
    fullPage: true,

    valid: true,
    ID: "0",
    opis: "",
    date: null, //For datepicker
    jm_items: [],
    jm_items_dodatak: [],
    Parameter_items: [],
    sarza_items: [],
    tip_tanka: 0,
    select: undefined,
    parameter_select: "",
    sarza_select: [],
    izabrani_barici: [],
    value: "0",
    menu: "",
    tankPhaseWineId: 0,
    time: undefined,
    menu1: "",
    kolicinaVina: 0,
    faza_mark: "",
    jm_mark: "",
    rules: {
      required: (value) => !!value || "Required.",
      password: (value) => {
        // const pattern = /^[1-9]\d*(\/\d+)?$/;
        // const pattern = /^\d*[\.\d+]*(\/\d*[\.\d+])?$/;

        const pattern = /^\d*(\.\d+)*(\/)\d*(\.\d+)?$/;

        return pattern.test(value) || "Obavezan podatak";
      },
    },

    date: null,
    dateFormatted: null,
    edit: true,
    pre_flasiranja: false
  }),
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate1(this.date);
    },
  },
  computed: {
    maxDate() {
      const today = new Date();
      // const dd = today.getUTCDate();
      return this.formatDate(today);
    },
  },
  methods: {
    formatDate1(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    getFieldText(item) {
      let tekst = "";

      if (item.id !== undefined) {
        if (
          item.batchPrefix !== null &&
          item.tankNumberInBatch !== null &&
          item.batchPrefix !== "" &&
          item.tankNumberInBatch !== ""
        )
          if (
            item.tank.inventoryNumber !== null &&
            item.tank.inventoryNumber !== undefined
          )
            tekst = `${item.batchPrefix} - ${item.tankNumberInBatch} | ${item.tank.name} | ${item.tank.inventoryNumber}`;
          else
            tekst = `${item.batchPrefix} - ${item.tankNumberInBatch} | ${item.tank.name})`;
        else if (
          (item.batchPrefix === null || item.batchPrefix === "") &&
          (item.tankNumberInBatch === null || item.tankNumberInBatch === "")
        )
          if (
            item.tank.inventoryNumber !== null &&
            item.tank.inventoryNumber !== undefined
          )
            tekst = `${item.tank.name} | ${item.tank.inventoryNumber}`;
          else tekst = `${item.tank.name}`;
        else if (
          item.tankNumberInBatch === null ||
          item.tankNumberInBatch === ""
        )
          if (
            item.tank.inventoryNumber !== null &&
            item.tank.inventoryNumber !== undefined
          )
            tekst = `${item.batchPrefix} | ${item.tank.name} | ${item.tank.inventoryNumber}`;
          else tekst = `${item.batchPrefix} (${item.tank.name})`;
        else if (item.batchPrefix === null || item.batchPrefix === "")
          if (
            item.tank.inventoryNumber !== null &&
            item.tank.inventoryNumber !== undefined
          )
            tekst = `${item.tankNumberInBatch} | ${item.tank.name} | ${item.tank.inventoryNumber}`;
          else tekst = `${item.tankNumberInBatch} | ${item.tank.name}`;
      }

      return tekst;
    },
    allowedStep: (m) => m % 5 === 0,
    formatDate(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join("-");
    },
    setTime() {
      const today = new Date();
      let Minutes = `${today.getMinutes()}`;
      let Hours = `${today.getHours()}`;

      if (Hours.length < 2) Hours = `0${Hours}`;
      if (Minutes.length < 2) Minutes = `0${Minutes}`;

      this.time = [Hours, Minutes].join(":");
    },
    setDate() {
      const today = new Date();
      let Year = `${today.getFullYear()}`;
      let Month = `${today.getMonth() + 1}`;
      let Day = `${today.getDate()}`;

      if (Month.length < 2) Month = `0${Month}`;
      if (Day.length < 2) Day = `0${Day}`;

      this.date = [Year, Month, Day].join("-");
    },
    formatTime(time) {
      let HH = time.split(":")[0];
      let mm = time.split(":")[1];

      return HH + ":" + mm;
    },
    newSifarnik() {
      if (this.parameter_select !== undefined) {
        var complexObjectSarza = [];

        let objekat;

        if (this.sarza_select !== undefined) {
          this.sarza_select.forEach(function (entry) {
            if (entry.tank !== undefined)
              objekat = {
                tank: {
                  id: entry.tank.id,
                },
              };
            else
              objekat = {
                tank: {
                  id: entry,
                },
              };
            complexObjectSarza.push(objekat);
          });
        }

        var complexObjectTankPhaseWine = {
          id: this.tankPhaseWineId,
        };

        var complexObjectUnitOfMeasure = {
          id: this.select.id,
        };

        var complexObjectAdditiv = {
          id: this.parameter_select.id,
        };

        if (complexObjectSarza.length === 0)
          var complexObject = {
            tankPhaseWine: complexObjectTankPhaseWine,
            parameter: complexObjectAdditiv,
            value: this.value,
            unitOfMeasure: complexObjectUnitOfMeasure,
            date: this.date + "T" + this.time,
            description: this.opis,
            beforeBottling: this.pre_flasiranja
          };
        else
          var complexObject = {
            tankPhaseWine: complexObjectTankPhaseWine,
            parameter: complexObjectAdditiv,
            value: this.value,
            unitOfMeasure: complexObjectUnitOfMeasure,
            date: this.date + "T" + this.time,
            description: this.opis,
            tankFromBatchInOperations: complexObjectSarza,
            beforeBottling: this.pre_flasiranja
          };

        // console.log(JSON.stringify(complexObject));

        this.$http
          .post(
            this.globalServiceLocation +
              this.globalPort +
              "/measurement/create",
            complexObject,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            }
          )
          .then((response) => {
            this.isLoading = false;
            serverBus.$emit("refresh_measurement", this.tip_tanka);

            this.clear();
          })
          .catch((e) => {
            if (!e.response) {
              this.isLoading = false;
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    // // console.log(result);
                    // // console.log("Novi token - " + localStorage.getItem("user-token"));

                    this.$http
                      .post(
                        this.globalServiceLocation +
                          this.globalPort +
                          "/measurement/create",
                        complexObject,
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        this.isLoading = false;
                        serverBus.$emit("refresh_measurement", this.tip_tanka);

                        this.clear();
                      })
                      .catch((e) => {
                        this.isLoading = false;

                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      });
                  });
              } else {
                this.isLoading = false;

                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      }
    },
    changeSifarnik() {
      var complexObjectTankPhaseWine = {
        id: this.tankPhaseWineId,
      };

      var complexObjectUnitOfMeasure = {
        id: this.select.id,
      };

      var complexObjectAdditiv = {
        id: this.parameter_select.id,
      };

      var complexObjectSarza = [];

      if (this.tip_tanka === "15") {
        let objekat;

        if (this.sarza_select !== undefined) {
          let _this = this;

          this.sarza_select.forEach(function (entry) {
            if (entry.tank !== undefined)
              objekat = {
                id: entry.id,
                tank: {
                  id: entry.tank.id,
                },
              };
            else {
              let ind = _this.izabrani_barici.findIndex(
                (x) => x.tank.id === entry
              );

              if (ind >= 0) {
                objekat = {
                  id: _this.izabrani_barici[ind].id,
                  tank: {
                    id: entry,
                  },
                };
              } else
                objekat = {
                  tank: {
                    id: entry,
                  },
                };
            }

            complexObjectSarza.push(objekat);
          });
        }
      }

      var complexObject;

      if (complexObjectSarza.length === 0)
        complexObject = {
          id: this.ID,
          tankPhaseWine: complexObjectTankPhaseWine,
          parameter: complexObjectAdditiv,
          value: this.value,
          unitOfMeasure: complexObjectUnitOfMeasure,
          date: this.date + "T" + this.time,
          description: this.opis,
            beforeBottling: this.pre_flasiranja
        };
      else
        complexObject = {
          id: this.ID,
          tankPhaseWine: complexObjectTankPhaseWine,
          parameter: complexObjectAdditiv,
          value: this.value,
          unitOfMeasure: complexObjectUnitOfMeasure,
          date: this.date + "T" + this.time,
          description: this.opis,
          tankFromBatchInOperations: complexObjectSarza,
            beforeBottling: this.pre_flasiranja
        };

      //// // console.log(complexObject);

      this.$http
        .put(
          this.globalServiceLocation + this.globalPort + "/measurement/update",
          complexObject,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.isLoading = false;
          
          serverBus.$emit("refresh_measurement", this.tip_tanka);

          this.clear();
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            this.isLoading = false;
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/measurement/update",
                      complexObject,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.isLoading = false;
                      serverBus.$emit("refresh_measurement", this.tip_tanka);

                      this.clear();
                    })
                    .catch((e) => {
                      this.isLoading = false;

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              this.isLoading = false;

              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    changeRoute(a) {
      if (typeof a !== "undefined") {
        // // // console.log(a.id);
        let obj = this.Parameter_items;

        for (var i = 0; i < obj.length; i++) {
          // look for the entry with a matching `code` value
          if (obj[i].id == a.id) {
            if (obj[i].unitOfMeasure !== null)
              if (obj[i].unitOfMeasure.length !== 0) {
                this.jm_items_dodatak = obj[i].unitOfMeasure;

                if (obj[i].unitOfMeasure.length === 1)
                  this.select = obj[i].unitOfMeasure[0];
              } else {
                this.jm_items_dodatak = this.jm_items;

                if (this.jm_items.length === 1) this.select = this.jm_items[0];
              }
            else {
              this.jm_items_dodatak = this.jm_items;

              if (this.jm_items.length === 1) this.select = this.jm_items[0];
            }
          }
        }
      }
    },
    getAllJediniceMere() {
      this.$http
        .get(
          this.globalServiceLocation + this.globalPort + "/unit_of_measure/all",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          //// // console.log(response.data);

          this.jm_items = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/unit_of_measure/all",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      //// // console.log(response.data);

                      this.jm_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllSarze(id_sarze, item) {
      let url;

      if (this.tankPhaseWineId !== 0)
        url =
          this.globalServiceLocation +
          this.globalPort +
          "/tank/tanks_in_batch/" +
          id_sarze +
          "/modal?tpwId=" +
          this.tankPhaseWineId;
      else
        url =
          this.globalServiceLocation +
          this.globalPort +
          "/tank/tanks_in_batch/" +
          id_sarze +
          "/modal";

      this.$http
        .get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          // console.log(response.data);
          this.sarza_items = response.data;

          let objPom = [];

          if (this.ID !== 0 && item !== null) {
            item.tankFromBatchInOperations.forEach(function (entry) {
              objPom.push(entry);
            });

            this.sarza_select = objPom;
            this.izabrani_barici = objPom;
          }
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(url, {
                      headers: {
                        "Content-Type": "application/json",
                        Authorization:
                          "Bearer  " + localStorage.getItem("user-token"),
                      },
                    })
                    .then((response) => {
                      this.sarza_items = response.data;

                      let objPom = [];

                      if (this.ID !== 0 && item !== null) {
                        item.tankFromBatchInOperations.forEach(function (
                          entry
                        ) {
                          objPom.push(entry);
                        });

                        this.sarza_select = objPom;
                        this.izabrani_barici = objPom;
                      }
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllParameter() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/parameter/production",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.Parameter_items = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/parameter/production",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.Parameter_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;

        setTimeout(() => {
          if (this.ID != "" && this.ID != "0") this.changeSifarnik();
          else this.newSifarnik();

          // this.isLoading = false;
        }, 1000);

        // this.clear();
      }
    },
    clear() {
      this.$refs.element1.reset();
      this.$refs.element2.reset();
      this.$refs.element3.reset();
      this.$refs.element4.reset();
      this.$refs.element5.reset();

      if (this.ID !== 0) {
        this.ID = 0;
        this.sarza_select = [];
      }

      this.sarza_select = [];

      this.izabrani_barici = [];

      if (this.tank_type === "batch") this.getAllSarze(this.id_tank, null);
    },
  },
  created() {
    //// // console.log(this.$route.query);

    this.tankPhaseWineId = this.$route.query.id;
  },
  mounted() {
    this.clear();
    this.setTime();
    this.setDate();

    if (this.$refs.elementsarza !== undefined) this.$refs.elementsarza.reset();

    this.getAllJediniceMere();
    this.getAllParameter();

    serverBus.$on("applied_measurement", (item) => {
      this.id_tank_phase_wine_blend = item.tankPhaseWineBlendId;
      this.opis = item.description;

      this.pre_flasiranja = item.beforeBottling;

      this.date = item.date.split("T")[0];
      this.time = this.formatTime(item.date.split("T")[1]);

      this.ID = item.id;
      this.value = item.value;

      if (item.unitOfMeasure !== null) {
        this.select = item.unitOfMeasure;
      } else {
        this.select = undefined;
      }

      if (item.parameter !== null) {
        this.parameter_select = item.parameter;
      } else {
        this.parameter_select = "";
      }

      this.sarza_select = [];

      if (item.tankFromBatchInOperations.length > 0) {
        let objPom = [];

        if (this.ID !== 0 && item !== null) {
          let _this = this;

          item.tankFromBatchInOperations.forEach(function (entry) {
            objPom.push(entry);

            let pomocniObj;
            pomocniObj = {
              batchPrefix: entry.tank.batchPrefix.split("-")[0],
              batchTank: null,
              id: 777,
              tank: {
                capacity: entry.tank.capacity,
                id: entry.tank.id,
                inventoryNumber: entry.tank.inventoryNumber,
                name: entry.tank.name,
                unitOfMeasure: entry.tank.unitOfMeasure,
              },
              tankNumberInBatch: entry.tank.batchPrefix.split("-")[1],
            };
            _this.sarza_items.push(pomocniObj);
          });

          // this.sarza_items.sort( this.compare );

          this.sarza_select = objPom;
          this.izabrani_barici = objPom;
        }
      } else if (this.ID !== 0 && item !== null) {
        this.sarza_select = [];
        this.izabrani_barici = [];
      }
    });

    serverBus.$on(
      "measurement",
      (id, kolicina_vina, faza_mark, jm_mark, id_tank, tip_tanka, edit, tank_phase_vine_blendId, faza_za_flasiranje) => {
        // alert('measurement');

        this.tankPhaseWineId = id;

        if (typeof edit !== "undefined") this.edit = edit;
        else this.edit = true;

        this.kolicinaVina = kolicina_vina;
        this.faza_mark = faza_mark;
        this.jm_mark = jm_mark;

        debugger

        this.faza_za_flasiranje = faza_za_flasiranje;

        // alert(this.id)
        // alert(this.id_tank)

        this.tip_tanka = tip_tanka;
        this.getAllSarze(id_tank, null);
      }
    );
  },
};
</script>

<style lang="scss" scoped>
.measurementItemComponentForm {
  max-width: 430px;
}

.Description textarea {
  height: 40px;
}

// .v-input.v-text-field {
// 	margin: 0px;
// }

div.v-input.Description.v-textarea.v-text-field {
  margin-top: 0px;
}

div.flex.pa-2 {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}
</style>
